import { useEffect } from 'react';

/**
 * usePanelClose
 * Closes a panel on Escape key or click outside the given ref.
 * No-op when open=false.
 *
 * @param {boolean}         open    - panel open state
 * @param {React.RefObject} ref     - ref of the panel element
 * @param {Function}        onClose - called when close condition is met
 */
export default function usePanelClose(open, ref, onClose) {
    // Close on click outside the panel element
    useEffect(() => {
        if (!open) return;

        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open, ref, onClose]);

    // Close on Escape key
    useEffect(() => {
        if (!open) return;

        const handleKey = (e) => {
            if (e.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [open, onClose]);
}
